import { Reducer } from 'redux';
import { RepaymentActionTypes } from '../constants/actionTypes';
import {
  ICreateRepaymentDataAction,
  ICreateRepaymentErrorDataAction,
  ICreateRepaymentSuccessDataAction, ICreatedRepaymentsState, IRepaymentsSuccessDataAction,
  IRepaymentState, IConfirmRepaymentSuccessDataAction, IConfirmRepaymentState,
  ISelectRepaymentSuccessDataAction,
} from '../types/RepaymentTypes';

const initialState: IRepaymentState = {
  error: [],
  createdRepaymentsStateData: undefined,
  selectedRepaymentStateData: undefined,
};

const repaymentReducer: Reducer<IRepaymentState, ICreateRepaymentDataAction> = (
  state = initialState,
  action: ICreateRepaymentDataAction,
) => {
  switch (action.type) {
    case RepaymentActionTypes.CREATE_REPAYMENT:
      return {
        ...state,
        error: [],
        createRepaymentStateData: (action as ICreateRepaymentSuccessDataAction).payload,
      } as IRepaymentState;
    case RepaymentActionTypes.ERROR_CREATE_REPAYMENT:
      return {
        ...state,
        createdRepaymentsStateData: undefined,
        error: (action as ICreateRepaymentErrorDataAction).errors,
      } as IRepaymentState;
    case RepaymentActionTypes.GET_CREATED_REPAYMENTS:
      return {
        ...state,
        createdRepaymentsStateData: (action as IRepaymentsSuccessDataAction).payload,
      } as ICreatedRepaymentsState;
    case RepaymentActionTypes.CONFIRM_REPAYMENT:
      return {
        ...state,
        confirmedRepaymentStateData: (action as IConfirmRepaymentSuccessDataAction).payload,
        confirmedRepaymentStateError: [],
      } as IConfirmRepaymentState;
    case RepaymentActionTypes.ERROR_CONFIRM_REPAYMENT:
      return {
        ...state,
        confirmedRepaymentStateData: undefined,
        confirmedRepaymentStateError: (action as ICreateRepaymentErrorDataAction).errors,
      } as IConfirmRepaymentState;
    case RepaymentActionTypes.SET_REPAYMENT_INFORMATION:
      return {
        ...state,
        selectedRepaymentStateData: (action as ISelectRepaymentSuccessDataAction).payload,
        selectedRepaymentStateLoadingState: false,
      } as IRepaymentState;
    case RepaymentActionTypes.ERROR_SET_REPAYMENT_INFORMATION:
      return {
        ...state,
        selectedRepaymentStateError: (action as ICreateRepaymentErrorDataAction).errors,
        selectedRepaymentStateLoadingState: false,
        selectedRepaymentStateData: undefined,
      } as IRepaymentState;
    case RepaymentActionTypes.LOAD_REPAYMENT_INFORMATION:
      return {
        ...state,
        selectedRepaymentStateLoadingState: true,
      } as IRepaymentState;
    case RepaymentActionTypes.CLEAR_REPAYMENT_INFORMATION:
      return {
        ...state,
        selectedRepaymentStateData: undefined,
        selectedRepaymentStateError: undefined,
        selectedRepaymentStateLoadingState: false,
      } as IRepaymentState;
    default: return state;
  }
};

export default repaymentReducer;
